import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import './Partners.css';

const Partners = () => {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [partnersPerPage] = useState(10);

  useEffect(() => {
    fetchPartners();
  }, []);

  const fetchPartners = async () => {
    try {
      setLoading(true);

      // Fetch beAPartner collection
      
      const partnersSnapshot = await getDocs(collection(db, 'beAPartner'));

      const partnersList = [];
      
      partnersSnapshot.forEach((doc) => {
        const partnerData = doc.data();

        partnersList.push({
          id: doc.id,
          name: partnerData.name || 'Unknown',
          mobileNumber: partnerData.mobileNuber || partnerData.mobileNumber || 'N/A',
          email: partnerData.email || 'N/A',
          address: partnerData.address || 'N/A',
          education: partnerData.education || 'N/A',
          profession: partnerData.profession || 'N/A',
          createdAt: partnerData.createdAt ? new Date(partnerData.createdAt.seconds * 1000) : null
        });
      });

      setPartners(partnersList);
    } catch (error) {
      console.error('❌ Error fetching partners:', error);
      setPartners([]);
    } finally {
      setLoading(false);
    }
  };

  // Filter partners based on search term
  const filteredPartners = partners.filter(partner => {
    const nameStr = String(partner.name || '').toLowerCase();
    const phoneStr = String(partner.mobileNumber || '');
    const emailStr = String(partner.email || '').toLowerCase();
    
    return nameStr.includes(searchTerm.toLowerCase()) ||
           phoneStr.includes(searchTerm) ||
           emailStr.includes(searchTerm.toLowerCase());
  });

  // Pagination
  const indexOfLastPartner = currentPage * partnersPerPage;
  const indexOfFirstPartner = indexOfLastPartner - partnersPerPage;
  const currentPartners = filteredPartners.slice(indexOfFirstPartner, indexOfLastPartner);
  const totalPages = Math.ceil(filteredPartners.length / partnersPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  if (loading) {
    return (
      <div className="partners-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading partners...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="partners-page">
      <div className="page-header partners-header">
        <h2>Partners</h2>
        <div className="partners-header-actions">
          <div className="search-container">
            <input
              type="text"
              placeholder="Search partners by name, phone, or email..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>
        </div>
      </div>

      {/* Partners List */}
      <div className="partners-section">
        <div className="partners-content">
          {currentPartners.length > 0 ? (
            <>
              <div className="partners-table">
                <table>
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Name</th>
                      <th>Mobile Number</th>
                      <th>Email</th>
                      <th>Address</th>
                      <th>Education</th>
                      <th>Profession</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentPartners.map((partner, index) => (
                      <tr key={partner.id}>
                        <td>{indexOfFirstPartner + index + 1}</td>
                        <td>
                          <span className="name">{partner.name}</span>
                        </td>
                        <td>
                          <span className="phone-number">{partner.mobileNumber}</span>
                        </td>
                        <td>
                          <span className="email">{partner.email}</span>
                        </td>
                        <td>
                          <span className="address">{partner.address}</span>
                        </td>
                        <td>
                          <span className="education">{partner.education}</span>
                        </td>
                        <td>
                          <span className="profession">{partner.profession}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="pagination">
                  <button 
                    onClick={() => paginate(currentPage - 1)} 
                    disabled={currentPage === 1}
                    className="pagination-btn"
                  >
                    Previous
                  </button>
                  
                  {[...Array(totalPages)].map((_, index) => (
                    <button
                      key={index + 1}
                      onClick={() => paginate(index + 1)}
                      className={`pagination-btn ${currentPage === index + 1 ? 'active' : ''}`}
                    >
                      {index + 1}
                    </button>
                  ))}
                  
                  <button 
                    onClick={() => paginate(currentPage + 1)} 
                    disabled={currentPage === totalPages}
                    className="pagination-btn"
                  >
                    Next
                  </button>
                </div>
              )}
            </>
          ) : (
            <div className="no-data">
              <div className="no-data-icon">🤝</div>
              <h3>No Partners Found</h3>
              <p>No partner applications found.</p>
            </div>
          )}
        </div>
      </div>

    </div>
  );
};

export default Partners;
